import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_051",
  "use": "icon-wo_051-usage",
  "viewBox": "0 0 40 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 52\" id=\"icon-wo_051\"><defs><style>#icon-wo_051 .cls-1{fill:#178;}</style></defs><g id=\"icon-wo_051_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_051_icon\"><path class=\"cls-1\" d=\"M20,52l-6-6.66C9.82,40.63,0,28.75,0,20a20,20,0,0,1,40,0c0,8.75-9.82,20.64-14,25.34ZM20,4A16,16,0,0,0,4,20c0,6,6.73,15.66,13,22.67h0L20,46l3-3.33C29.27,35.66,36,26,36,20A16,16,0,0,0,20,4Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol